import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_TIMEZONE } from '../query';
export var initialState = {
  defaultTimezoneForQuery: DEFAULT_TIMEZONE,
  isLoading: false,
  error: null,
  timezoneSelectionDisabled: false,
  timezones: []
};
export var timezoneSlice = createSlice({
  name: 'timezone',
  initialState: initialState,
  reducers: {
    setDefaultTimezone: function setDefaultTimezone(state, _ref) {
      var payload = _ref.payload;
      state.defaultTimezoneForQuery = payload;
    },
    setTimezoneSelectionDisabled: function setTimezoneSelectionDisabled(state, _ref2) {
      var payload = _ref2.payload;
      state.timezoneSelectionDisabled = payload;
    },
    setError: function setError(state, _ref3) {
      var payload = _ref3.payload;
      state.error = payload;
    },
    setTimezonesLoading: function setTimezonesLoading(state, _ref4) {
      var payload = _ref4.payload;
      state.isLoading = payload;
    },
    setTimezones: function setTimezones(state, _ref5) {
      var payload = _ref5.payload;
      state.timezones = payload;
      state.error = false;
      state.isLoading = false;
    }
  }
});